// import vuex from '@/store/'

import { useContentStore } from '@/stores/content'

export const isBlacklistedIRPIDParam = () => {
    const irpidParam = window.irpidparameter
    const BlackListedIRPID = useContentStore().blacklistedIRPID
    return BlackListedIRPID.some(blackListedIRPID => irpidParam === blackListedIRPID.value)
  }
